import React from "react";
import { leadershipOrg, leadershipRoles } from "../../data/leadership";
import { nodeId } from "../../data/connections";
import DossierFolder from "../../components/investigation/DossierFolder";
import EvidenceCard from "../../components/investigation/EvidenceCard";
import EvidenceImage from "../../components/investigation/EvidenceImage";
import CaseStamp from "../../components/investigation/CaseStamp";
import { detailFromLeadershipOrg, detailFromLeadershipRole } from "../../utils/evidenceDetail";

export const LeadershipSection = () => (
  <div className="leadership-cluster">
    <EvidenceCard
      variant="paper"
      pin={false}
      rotate={0}
      className="leadership-cover-card"
      nodeId={nodeId.org(leadershipOrg.id)}
      detail={detailFromLeadershipOrg()}
    >
      <DossierFolder tab="VOLUNTEER OPS" className="leadership-cover">
        <EvidenceImage
          src={leadershipOrg.logo}
          alt=""
          variant="logo"
          pin={false}
          placeholderLabel="ORGANIZATION MARK"
        />
        <h3>{leadershipOrg.title}</h3>
        <p>{leadershipOrg.company}</p>
        <p className="timeline-dates">{leadershipOrg.duration}</p>
        {leadershipOrg.current ? (
          <CaseStamp tone="red" rotate={-6} className="tiny-stamp">
            Active
          </CaseStamp>
        ) : null}
      </DossierFolder>
    </EvidenceCard>

    <div className="evidence-group">
      <p className="evidence-group-label">
        Roles on record <span>· also answers to “Operations Manager”</span>
      </p>
      <div className="leadership-stack">
        {leadershipRoles.map((role, index) => (
          <EvidenceCard
            key={role.id}
            variant="paper"
            pin={role.current ? "red" : "black"}
            rotate={index % 2 === 0 ? -0.6 : 0.7}
            className="leadership-card"
            detail={detailFromLeadershipRole(role)}
          >
            <p className="timeline-dates">{role.duration}</p>
            <h3>{role.title}</h3>
            <p className="timeline-stack">{role.skills}</p>
          </EvidenceCard>
        ))}
      </div>
    </div>
  </div>
);

export default LeadershipSection;
